/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-empty */
import {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError,
  AxiosInstance,
} from 'axios';
import chalk from 'chalk';
import Bugsnag from '../bugsnag';
import Bundle from '_core/util/bundle';
import { InitializeTypes } from '_core/types';
import EventsHelper from '../events/EventsHelper';
import { Logger } from '../logger';
import { isNull, isValue } from '_core/util';

interface ICustomAxiosRequestConfig extends AxiosRequestConfig {
  metadata?: any;
}

export const configureAxiosIntLogger = (
  instance: AxiosInstance,
  config: InitializeTypes,
) => {
  const isLoggerService = config.service.logger;
  const isLoggerEvents = config.channel === 'WEB_FLOW' ? true : false;

  try {
    const idInterceptorRequest = Bundle.getValue('idInterceptorAxiosRequest');
    if (isValue(idInterceptorRequest)) {
      instance.interceptors.request.eject(idInterceptorRequest);
    }
  } catch (error) {
    Logger.error(error);
  }

  try {
    const idInterceptorAxiosRequest = instance.interceptors.request.use(
      (request: ICustomAxiosRequestConfig) => {
        request.metadata = { requestStartTime: new Date() };
        prepareLogRequest(request, isLoggerService, isLoggerEvents);
        return request;
      },
      (error: any[] | undefined) => {
        Logger.error('Request Send Error : ', error);

        return Promise.reject(error);
      },
    );
    Bundle.setValue('idInterceptorAxiosRequest', idInterceptorAxiosRequest);
  } catch (error) {
    Logger.error(error);
  }

  try {
    const idInterceptorResponse = Bundle.getValue('idInterceptorAxiosResponse');
    if (isValue(idInterceptorResponse)) {
      instance.interceptors.request.eject(idInterceptorResponse);
    }
  } catch (error) {
    Logger.error(error);
  }

  try {
    const idInterceptorAxiosResponse = instance.interceptors.response.use(
      (response: AxiosResponse) => {
        // TODO Ajustar o TS do AxiosResponse, para conseguir pegar o requestStartTime do metadata
        // const timeStart = response.config.metadata.requestStartTime;
        const timeStart = new Date();
        prepareLogResponse(
          response,
          timeStart,
          isLoggerService,
          isLoggerEvents,
        );
        return response;
      },
      (error: any) => {
        // const timeStart = error.config.metadata.requestStartTime;
        // const timeStart = error.config.headers['request-startTime'];
        const timeStart = new Date();
        prepareLogResponseError(
          error,
          timeStart,
          isLoggerService,
          isLoggerEvents,
        );
        return Promise.reject(error);
      },
    );
    Bundle.setValue('idInterceptorAxiosResponse', idInterceptorAxiosResponse);
  } catch (error) {
    Logger.error(error);
  }
};

const prepareLogRequest = (
  requetConfig: AxiosRequestConfig,
  isLoggerService: boolean,
  isLoggerEvents: boolean,
) => {
  let msg =
    '\n\n----------------------------------------------------------------\n\n';
  const { data, headers, method, url, params } = requetConfig;

  msg += `${chalk.green.bold('[Axios Request]   ')}${chalk.yellow.bold(
    '0ms \n\n',
  )}`;

  msg += method ? `${chalk.yellow.bold(method.toUpperCase())}  ` : '';

  let newUrl = url;
  if (!isNull(params)) {
    const searchParams = prepareUrlParams(params);
    newUrl += searchParams;
  }

  msg += newUrl ? `${chalk.cyan(newUrl)}\n` : '';

  const lstHeaders: any[] = [];
  if (headers) {
    msg += chalk.yellow.bold('Headers:');
    for (const key in headers) {
      if (typeof headers[key] === 'string') {
        msg += `\n  ${key}: ${headers[key]}`;
        lstHeaders.push({ key: key, value: headers[key] });
      }
    }
  }

  if (data) {
    const dataStr = JSON.stringify(data, null, 3);
    msg += `\n${chalk.yellow.bold('Body: ')} \n${chalk.bold(dataStr)}\n`;
  }
  // msg += '----------------------------------------------------------------';
  if (isLoggerService) Logger.log(msg);

  if (isLoggerEvents) {
    const baseUrl = Bundle.getValue('service-endpoint');
    const path = new String(url).replace(baseUrl, '');
    const formatedEvent = { path, message: msg.toString() };
    EventsHelper.emitMessage('api-request', formatedEvent);
  }
};

const prepareLogResponse = (
  response: AxiosResponse,
  timeStart: any,
  isLoggerService: boolean,
  isLoggerEvents: boolean,
) => {
  const time = calculateTime(timeStart);
  let msg = '\n';
  // '\n----------------------------------------------------------------\n\n';

  const isMock =
    response &&
    response.headers &&
    response.headers.mockEnabled &&
    response.headers.mockEnabled === true;

  msg += isMock
    ? `${chalk.magenta.bold(
        '***---***---***---***  MOCK ENABLED  ***---***---***---***\n\n',
      )}`
    : '';

  msg += `${chalk.green.bold('[Axios Response Success]   ')}${chalk.yellow.bold(
    '+' + time + 'ms\n\n',
  )}`;

  const {
    config: { method, url },
  } = response;

  msg += method ? `${chalk.yellow.bold(method.toUpperCase())}  ` : '';
  msg += url ? `${chalk.cyan(url)}\n` : '';

  // let responseStatus: number | unknown = '';
  // let responseStatusText: number | unknown = '';
  let dataStr = ';';
  const lstResponseHeaders: any[] = [];
  if (response) {
    msg += response.status
      ? `${chalk.bold('  Status')}: ${chalk.green.bold(
          response.status.toString(),
        )}\n`
      : '';
    // responseStatus = response.status ? response.status : '';
    msg += response.statusText
      ? `${chalk.bold('  StatusText')}: ${chalk.yellow(response.statusText)}\n`
      : '';
    // responseStatusText = response.statusText ? response.statusText : '';

    if (response.headers) {
      msg += chalk.yellow.bold('Headers:');
      for (const key in response.headers) {
        msg += `\n  ${key}: ${response.headers[key]}`;
        lstResponseHeaders.push({ key: key, value: response.headers[key] });
      }
    }

    if (response.data) {
      if (typeof response.data !== 'object') {
        const json = isJsonValid(response.data);
        if (json != null) {
          dataStr = JSON.stringify(json, null, 3);
        }
      } else {
        dataStr = JSON.stringify(response.data, null, 3);
      }
      msg += `\n${chalk.yellow.bold('Body: ')} \n${chalk.bold(dataStr)}\n`;
    }
  }
  msg += '----------------------------------------------------------------\n';
  if (isLoggerEvents) {
    const baseUrl = Bundle.getValue('service-endpoint');
    const path = new String(url).replace(baseUrl, '');
    const formatedEvent = { path, message: msg.toString() };
    EventsHelper.emitMessage('api-response', formatedEvent);
  }
  if (isLoggerService) Logger.log(msg);
};

const prepareLogResponseError = (
  error: AxiosError,
  timeStart: any,
  isLoggerService: boolean,
  isLoggerEvents: boolean,
) => {
  const {
    config: { url, method },
    response,
    message,
  } = error;

  const isMock =
    response &&
    response.headers &&
    response.headers.mockEnabled &&
    response.headers.mockEnabled === true;

  const time = calculateTime(timeStart);
  let msg = '';
  //'\n----------------------------------------------------------------\n\n';
  msg += isMock
    ? `${chalk.magenta.bold(
        '***---***---***---***  MOCK ENABLED  ***---***---***---***\n\n',
      )}`
    : '';
  msg += `${chalk.green.bold('[Axios Response ')}${chalk.red.bold(
    'Error]   ',
  )}${chalk.yellow.bold('+' + time + 'ms\n\n')}`;

  msg += method ? `${chalk.yellow.bold(method.toUpperCase())}  ` : '';
  msg += url ? `${chalk.cyan(url)}\n` : '';
  let dataStr = '';
  // let responseStatus: number | unknown = '';
  // let responseStatusText: number | unknown = '';
  const lstResponseHeaders: any[] = [];
  if (response) {
    msg += response.status
      ? `${chalk.bold('  Status')}: ${chalk.magenta.bold(
          response.status.toString(),
        )}\n`
      : '';
    // responseStatus = response.status ? response.status : '';
    msg += response.statusText
      ? `${chalk.bold('  StatusText')}: ${chalk.yellow(response.statusText)}\n`
      : '';
    // responseStatusText = response.statusText ? response.statusText : '';
    if (response.headers) {
      msg += chalk.yellow.bold('Headers:');
      for (const key in response.headers) {
        msg += `\n  ${key}: ${response.headers[key]}`;
        lstResponseHeaders.push({ key: key, value: response.headers[key] });
      }
    }
    if (response.data) {
      dataStr = '';
      if (typeof response.data !== 'object') {
        const json = isJsonValid(response.data);
        if (json != null) {
          dataStr = JSON.stringify(json, null, 3);
        }
      } else {
        dataStr = JSON.stringify(response.data);
      }
      msg += `\n${chalk.yellow.bold('Body: ')} \n${chalk.bold(dataStr)}\n`;
    }
  }

  if (message) {
    msg += `\n${chalk.yellow.bold('Message error:')} \n\n${chalk.red(
      message,
    )}\n\n`;
  }

  msg += '----------------------------------------------------------------\n';
  if (isLoggerEvents) {
    const baseUrl = Bundle.getValue('service-endpoint');
    const path = new String(url).replace(baseUrl, '');
    const formatedEvent = { path, message: msg.toString() };
    EventsHelper.emitMessage('api-response', formatedEvent);
  }
  if (isLoggerService) Logger.log(msg);
  const config = Bundle.getValue('config');
  if (!isMock && config.bugSnagClient) {
    generateErroToBugsnag(error, dataStr, config.bugSnagClient);
  }
};

const generateErroToBugsnag = (
  error: AxiosError,
  responseStr: string,
  bugnagClient: any,
) => {
  const environment = Bundle.getValue('service-environment');
  const {
    config: { data, url, method },
    response,
  } = error;

  const requestStr = data ? data : '';
  const status = response && response.status ? response.status : 999;
  const urlAux = url ? url : '';
  const methodAux = method ? method : '';
  Bugsnag.sendErrorApi(
    environment,
    urlAux,
    status,
    methodAux.toUpperCase(),
    requestStr,
    responseStr,
    bugnagClient,
    'teste',
  );
};

const isJsonValid = (str: string) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
};

const prepareUrlParams = (params: any) => {
  let paramsStr = '';
  let isItemZero = true;
  for (const [key, value] of Object.entries(params)) {
    if (!isItemZero) {
      paramsStr += `&${key}=${value}`;
    } else {
      isItemZero = false;
      paramsStr += `?${key}=${value}`;
    }
  }
  return paramsStr;
};

const calculateTime = (timeStart: Date) => {
  let milliseconds = 0;
  try {
    const end = new Date();
    milliseconds = end.getTime() - timeStart.getTime();
  } catch (error) {
    Logger.info(error);
  }
  return milliseconds;
};
